import { Link, useLocation } from 'react-router-dom';
import { BRAND } from '../../data/constants.js';

export default function MobileBottomNav({ favs = [] }) {
  const loc = useLocation();
  const is = p => loc.pathname === p;
  return (
    <nav className="mbn" aria-label="Navegación principal">
      <Link className={"mbn-item" + (is('/') ? ' on' : '')} to="/">🏠<span>Inicio</span></Link>
      <Link className={"mbn-item" + (loc.pathname === '/buscar' ? ' on' : '')} to="/buscar?op=venta">🔍<span>Buscar</span></Link>
      <Link className={"mbn-item" + (is('/favoritos') ? ' on' : '')} to="/favoritos">
        <div className="mbn-ic-wrap">
          ♥{favs.length > 0 && <span className="mbn-badge">{favs.length}</span>}
        </div>
        <span>Guardados</span>
      </Link>
      <a className="mbn-item mbn-wa" href={`https://wa.me/${BRAND.waVentas}`} target="_blank" rel="noopener">💬<span>WhatsApp</span></a>
    </nav>
  );
}
